import React, { useState, useEffect } from 'react';
import API from '../api/api';

export default function Revenues({ partnership, partners }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const _today = new Date().toISOString().split('T')[0];
  const [form, setForm] = useState({ partner_id: '', amount: '', note: '', date: _today, sender: '', transfer_date: _today, remark: '' });
  const [confirm, setConfirm] = useState(null);

  useEffect(() => { load(); }, [partnership.id]);

  const load = async () => {
    setLoading(true);
    const res = await API.get(`/detail-revenues/${partnership.id}/`);
    setData(res.data.revenues || []);
    setLoading(false);
  };

  const save = async (e) => {
    e.preventDefault();
    if (editItem) {
      await API.post(`/detail-revenues/${partnership.id}/`, { action: 'edit_revenue', id: editItem.id, ...form });
    } else {
      await API.post(`/detail-revenues/${partnership.id}/`, form);
    }
    setShowForm(false); setEditItem(null);
    setForm({ partner_id: '', amount: '', note: '', date: _today, sender: '', transfer_date: _today, remark: '' });
    load();
  };

  const doDelete = async () => {
    await API.post(`/detail-revenues/${partnership.id}/`, { action: 'delete_revenue', id: confirm });
    setConfirm(null); load();
  };

  const startEdit = (r) => {
    setEditItem(r);
    setForm({ partner_id: r.partner_id || '', amount: r.amount, note: r.note || '', date: r.date || '', sender: r.sender || '', transfer_date: r.transfer_date || '', remark: r.remark || '' });
    setShowForm(true);
  };

  const totalAll = data.reduce((s, r) => s + r.amount, 0);
  const inp = { width: '100%', padding: '7px', border: '1px solid #ddd', borderRadius: '5px', boxSizing: 'border-box', fontSize: '13px' };
  const lbl = { display: 'block', fontSize: '12px', fontWeight: 'bold', marginBottom: '4px' };
  const btn = (bg) => ({ padding: '7px 16px', background: bg, color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold' });

  if (loading) return <div style={{ textAlign: 'center', padding: '30px' }}>جار التحميل...</div>;

  return (
    <div style={{ padding: '15px' }} dir="rtl">
      {/* تأكيد الحذف */}
      {confirm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', padding: '25px', borderRadius: '10px', textAlign: 'center', minWidth: '280px' }}>
            <div style={{ fontSize: '40px', marginBottom: '10px' }}>⚠️</div>
            <p style={{ fontWeight: 'bold', marginBottom: '20px' }}>هل أنت متأكد من حذف هذا الإيراد؟</p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button onClick={doDelete} style={btn('#e74c3c')}>نعم، احذف</button>
              <button onClick={() => setConfirm(null)} style={btn('#95a5a6')}>إلغاء</button>
            </div>
          </div>
        </div>
      )}

      {/* هيدر */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
        <h3 style={{ margin: 0, color: '#1e3a5f' }}>💵 الإيرادات</h3>
        <button onClick={() => { setShowForm(true); setEditItem(null); setForm({ partner_id: '', amount: '', note: '', date: _today, sender: '', transfer_date: _today, remark: '' }); }} style={btn('#1e3a5f')}>+ إيراد جديد</button>
      </div>

      {/* ملخص */}
      <div style={{ background: 'white', padding: '12px', borderRadius: '8px', marginBottom: '15px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', display: 'flex', gap: '20px' }}>
        <div><span style={{ fontSize: '12px', color: '#666' }}>إجمالي الإيرادات</span><br /><strong style={{ color: '#27ae60', fontSize: '18px' }}>{totalAll.toLocaleString('ar-SA', {useGrouping:false, maximumFractionDigits: 2})} ر.س</strong></div>
        <div><span style={{ fontSize: '12px', color: '#666' }}>عدد الإيرادات</span><br /><strong style={{ fontSize: '18px' }}>{data.length}</strong></div>
      </div>

      {/* نموذج */}
      {showForm && (
        <form onSubmit={save} style={{ background: 'white', padding: '15px', borderRadius: '8px', marginBottom: '15px', boxShadow: '0 1px 6px rgba(0,0,0,0.1)' }}>
          <h4 style={{ margin: '0 0 12px' }}>{editItem ? '✏️ تعديل إيراد' : '➕ إيراد جديد'}</h4>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '10px', marginBottom: '10px' }}>
            <div>
              <label style={lbl}>الشريك</label>
              <select style={inp} value={form.partner_id} onChange={e => setForm({ ...form, partner_id: e.target.value })} required>
                <option value="">-- اختر --</option>
                {partners.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
              </select>
            </div>
            <div><label style={lbl}>المبلغ</label><input type="number" step="0.01" style={inp} value={form.amount} onChange={e => setForm({ ...form, amount: e.target.value })} required /></div>
            <div><label style={lbl}>تاريخ التسجيل</label><input type="date" style={inp} value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} required /></div>
            <div><label style={lbl}>الملاحظة</label><input style={inp} value={form.note} onChange={e => setForm({ ...form, note: e.target.value })} /></div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px', marginBottom: '10px' }}>
            <div><label style={lbl}>اسم المحوّل</label><input style={inp} value={form.sender} onChange={e => setForm({ ...form, sender: e.target.value })} /></div>
            <div><label style={lbl}>تاريخ التحويل</label><input type="date" style={inp} value={form.transfer_date} onChange={e => setForm({ ...form, transfer_date: e.target.value })} /></div>
            <div><label style={lbl}>بيان إضافي</label><input style={inp} value={form.remark} onChange={e => setForm({ ...form, remark: e.target.value })} /></div>
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button type="submit" style={btn('#27ae60')}>حفظ</button>
            <button type="button" onClick={() => { setShowForm(false); setEditItem(null); }} style={btn('#e74c3c')}>إلغاء</button>
          </div>
        </form>
      )}

      {/* الجدول */}
      <div style={{ overflowX: 'auto', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: '8px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white' }}>
          <thead style={{position:'sticky',top:0,zIndex:10}}>
            <tr style={{ background: '#1e3a5f', color: 'white' }}>
              {['#', 'الشريك', 'المبلغ', 'تاريخ التسجيل', 'الملاحظة', 'اسم المحوّل', 'تاريخ التحويل', 'بيان', ''].map(h => (
                <th key={h} style={{ padding: '10px 8px', fontSize: '12px', textAlign: 'right' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((r, i) => (
              <tr key={r.id} style={{ background: i % 2 === 0 ? 'white' : '#f8f9fa', borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '9px 8px', fontSize: '13px', fontWeight: 'bold' }}>{i + 1}</td>
                <td style={{ padding: '9px 8px', fontSize: '13px', fontWeight: 'bold' }}>{r.partner_name}</td>
                <td style={{ padding: '9px 8px', fontSize: '13px', fontWeight: 'bold', color: '#27ae60' }}>{r.amount.toLocaleString('ar-SA', {useGrouping:false, maximumFractionDigits: 2})} ر.س</td>
                <td style={{ padding: '9px 8px', fontSize: '12px' }}>{r.date}</td>
                <td style={{ padding: '9px 8px', fontSize: '12px' }}>{r.note || '—'}</td>
                <td style={{ padding: '9px 8px', fontSize: '12px' }}>{r.sender || '—'}</td>
                <td style={{ padding: '9px 8px', fontSize: '12px' }}>{r.transfer_date || '—'}</td>
                <td style={{ padding: '9px 8px', fontSize: '12px' }}>{r.remark || '—'}</td>
                <td style={{ padding: '9px 8px', whiteSpace: 'nowrap' }}>
                  <button onClick={() => startEdit(r)} style={{ padding: '4px 10px', background: '#f39c12', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', marginLeft: '5px' }}>✏️</button>
                  <button onClick={() => setConfirm(r.id)} style={{ padding: '4px 10px', background: '#e74c3c', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>🗑️</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
